import { mountRaceList } from './utils/mount-race-list.js';
import { LA_COUNTY_URL } from './constants.js';
import { SHARED_RACES } from './shared-races.js';

// first parameter here needs to match what's in the multipleRaces js file
mountRaceList('la-county-school-races', LA_COUNTY_URL, {
  // filter options: FilterSpec in stores.js
  filter: [
    {
      tagsAny: ['schools'],
      excludeIds: SHARED_RACES.map((race) => race.lavote),
      sort: 'title',
    },
  ],
  component: 'result', // to show 2 col table
  // Shows AP's race in place of L.A. Vote's for the ones set to 'ap'
  sharedRaces: SHARED_RACES,
  dropdown: 'school districts',
}).catch(console.error);
